import React, {useEffect} from 'react';
import MainTable from "../../components/main/MainTable";
import MT from "../../components/contents/home/MT";
import {connect} from 'react-redux';
import {fetchResults} from '../../redux/actions/resultActions';

const MainPage = (props) => {
    useEffect(() => {
        props.fetchResults();
    }, [props]);

    return (
        <div id="dnw-page">
            <div id="dnw-main">
                <div className="dnw-sheet">
                    <MainTable>
                        <MT/>
                    </MainTable>
                </div>
            </div>
        </div>
    )
};


export default connect(null, {fetchResults})(MainPage);
